import { RoleTypes } from '../rolesTypes';

export const returnRoleInclusion = (array: string[], values: RoleTypes[]) =>
  values.some((value) => array.includes(value));
